export const PLACE_MODES = {
  ALL: "all",
  NEARBY: "nearby",
  CITIES_AND_AIRPORTS: "citiesAndAirports",
  COUNTRIES: "countries",
  ANYWHERE: "anywhere",
  RADIUS: "radius",
  UNSELECTED: "unselected",
} as const

export const PLACE_VALUE_MODES = {
  TEXT: "text",
  PLACE: "place",
  RADIUS: "radius",
  ANYWHERE: PLACE_MODES.ANYWHERE,
  ID: "id",
  UNSELECTED: PLACE_MODES.UNSELECTED,
  MULTI_PLACE: "multiPlace",
} as const

export const PLACE_TYPES = {
  AIRPORT: 0,
  COUNTRY: 1,
  CITY: 2,
  TRAIN_STATION: 4,
  AUTONOMOUS_TERRITORY: 3,
  REGION: 5,
  CONTINENT: 6,
  BUS_STATION: 7,
  SPECIAL: 8,
  VIRTUAL: 999,
} as const

export const ORIGIN_MODES = [
  PLACE_MODES.ALL,
  // PLACE_MODES.NEARBY,
  PLACE_MODES.COUNTRIES,
  PLACE_MODES.RADIUS,
] as const

export const DESTINATION_MODES = [
  PLACE_MODES.ALL,
  // PLACE_MODES.NEARBY,
  PLACE_MODES.COUNTRIES,
  PLACE_MODES.ANYWHERE,
  PLACE_MODES.RADIUS,
] as const

// types
// =====
export type PlaceMode =
  | "all"
  | "nearby"
  | "cheapest"
  | "citiesAndAirports"
  | "countries"
  | "anywhere"
  | "radius"

export type PlaceValueMode = "text" | "place" | "radius" | "anywhere" | "id" | "unselected"

export type SimplePickerPlace = {
  modeDefault: PlaceMode
  modes: PlaceMode[]
}
